import { FC, useEffect, useMemo, useState } from 'react';
import { IModalComponentProps } from '@context/modal_context';
import KycDocuments from './kyc_documents';
import KycErrors from './kyc_errors';
import styles from './styles.module.scss';
import KycSuccess from './kyc_success';
import KycInfo from './kyc_info';
import KycLoading from './kyc_loading';

const KycModal: FC<
    IModalComponentProps<{ isError: boolean; codes: string[]; isSuccess: boolean }>
> = ({ onClose, modalData }) => {
    const [step, setStep] = useState(0);
    const [errors, setErrors] = useState<string[]>([]);

    const handleNextStep = () => {
        setStep((state) => state + 1);
    };

    useEffect(() => {
        if (modalData?.isError) {
            setStep(3);
            if (modalData?.codes) {
                setErrors(modalData.codes);
            }
        } else if (modalData?.isSuccess) {
            setStep(4);
        }
    }, [modalData]);

    const renderStep = useMemo(() => {
        switch (step) {
            case 0:
                return <KycInfo onClose={onClose} onSubmit={handleNextStep} />;
            case 1:
                return <KycDocuments onClose={onClose} handleNextStep={handleNextStep} />;
            case 2:
                return <KycLoading onClose={onClose} />;
            case 3:
                return (
                    <KycErrors
                        onClose={onClose}
                        errors={errors}
                        handleStart={() => {
                            setStep(0);
                            setErrors([]);
                        }}
                    />
                );
            case 4:
                return <KycSuccess onClose={onClose} />;
        }
    }, [step]);

    return <div className={styles.wrapper}>{renderStep}</div>;
};

export default KycModal;
